export const types = {
  SET_ARTISTS: "SET_ARTISTS",
  ADD_ARTIST: "ADD_ARTIST",
  UPDATE_ARTIST: "UPDATE_ARTIST",
  DELETE_ARTIST: "DELETE_ARTIST",
  HYDRATE_ARTISTS_FROM_SESSION: "HYDRATE_ARTISTS_FROM_SESSION",
};

export const setArtists = payload => ({
  type: types.SET_ARTISTS,
  payload,
});

export const addArtist = payload => ({
  type: types.ADD_ARTIST,
  payload,
});

export const updateArtist = payload => ({
  type: types.UPDATE_ARTIST,
  payload,
});

export const deleteArtist = payload => ({
  type: types.DELETE_ARTIST,
  payload,
});

export const hydrateArtistsFromSession = payload => ({
  type: types.HYDRATE_ARTISTS_FROM_SESSION,
  payload,
});
